
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.714 26h-6.001c-1.147 0-1.72 1.382-.911 2.197l1.763 1.661-5.316 5.32a.86.86 0 000 1.212l1.361 1.36a.86.86 0 001.211 0l5.321-5.32 1.666 1.768c.81.81 2.192.236 2.192-.91v-6.002c0-.713-.573-1.286-1.286-1.286zm6.572-4h6.001c1.147 0 1.72-1.388.911-2.197l-1.768-1.661 5.32-5.32a.86.86 0 000-1.212l-1.36-1.36a.86.86 0 00-1.211 0l-5.321 5.32-1.666-1.768c-.81-.81-2.192-.236-2.192.91v6.002c0 .713.573 1.286 1.286 1.286zm5.144 7.856l1.768-1.665c.81-.81.236-2.191-.91-2.191h-6.002c-.713 0-1.286.573-1.286 1.285v6c0 1.145 1.388 1.718 2.197.91l1.661-1.763 5.32 5.319a.86.86 0 001.212 0l1.36-1.36a.86.86 0 000-1.21l-5.32-5.325zM19.803 13.807l-1.661 1.763-5.32-5.32a.86.86 0 00-1.212 0l-1.36 1.36a.86.86 0 000 1.211l5.32 5.321-1.768 1.666c-.81.81-.236 2.192.91 2.192h6.002c.713 0 1.286-.573 1.286-1.286v-6.001c0-1.142-1.388-1.715-2.197-.906z","fill":"#535353"}})])
          )
        }
      }
    